/** Shared hourly-slot constants for frontend. Mirrors backend/core/hourly_slots.py */

export const HOURLY_SLOTS = [
  { id: 's1', label: '4 AM – 7 AM',  start: '04:00', end: '07:00', overnight: false },
  { id: 's2', label: '7 AM – 10 AM', start: '07:00', end: '10:00', overnight: false },
  { id: 's3', label: '10 AM – 1 PM', start: '10:00', end: '13:00', overnight: false },
  { id: 's4', label: '1 PM – 4 PM',  start: '13:00', end: '16:00', overnight: false },
  { id: 's5', label: '4 PM – 7 PM',  start: '16:00', end: '19:00', overnight: false },
  { id: 's6', label: '7 PM – 10 PM', start: '19:00', end: '22:00', overnight: false },
  { id: 's7', label: '10 PM – 1 AM', start: '22:00', end: '01:00', overnight: true },
  { id: 's8', label: '1 AM – 4 AM',  start: '01:00', end: '04:00', overnight: true },
];

export const SLOT_BY_ID = Object.fromEntries(HOURLY_SLOTS.map((s) => [s.id, s]));
